import React from 'react'
import { IVehicleGroupModel } from './VehicleGroupModel'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'

type Props = {
  data: IVehicleGroupModel[]
  currentPage: number
  totalPages: number
  pageSize: number
  pageSizeOptions?: number[]
  onPageSizeChange?: (size: number) => void
  onPageChange: (page: number) => void // Düzeltme: parametre tipi eklendi
  onEdit?: (vehicleGroup: IVehicleGroupModel) => void // Düzeltme: Edit fonksiyonu eklendi
  onDelete?: (vehicleGroup: IVehicleGroupModel) => void // Düzeltme: Delete fonksiyonu eklendi
  sortBy?: string // Düzeltme: Sort state'leri eklendi
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const VehicleGroupTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const vehicleGroupColumns: TableColumn<IVehicleGroupModel>[] = [
    { key: 'groupName', label: 'Araç Grubu Adı', className: 'fw-semibold' ,sortable: true},
    { key: 'webCarBrand', label: 'Web Araç Markası' },
    { key: 'webSort', label: 'Sayaç', sortable: true },
    { key: 'webCarType', label: 'Web Araç Türü' },
    { key: 'webId', label: 'Web ID' },
  ]

  // Düzeltme: TableAction'da IBranchModel tipini kullan
  const vehicleGroupActions: TableAction<IVehicleGroupModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (vehicleGroup) => onEdit?.(vehicleGroup), // Düzeltme: Parent'tan gelen fonksiyon
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (vehicleGroup) => onDelete?.(vehicleGroup), // Düzeltme: Parent'tan gelen fonksiyon
    },
  ]

  return (
    <DataTable
      data={data}
      columns={vehicleGroupColumns}
      actions={vehicleGroupActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      pageSizeOptions={pageSizeOptions}
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz Araç Grubu bulunamadı'
    />
  )
}